import React, {Suspense} from 'react';
import { BrowserRouter } from 'react-router-dom';

import ContextProvider from "./context";
import LazyLoader from "./components/Loading/LazyLoader";
import ErrorBoundary from "./components/Error/ErrorBoundary/ErrorBoundary";
import AppRoutes from "./routes/Routes";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import SocketEventHandler from "./context/socket/SocketEventHandler";

function App() {
    return (
        <ContextProvider>
            <BrowserRouter>
                <Suspense fallback={<LazyLoader />}>
                    <ErrorBoundary>
                        <ScrollToTop>
                            <SocketEventHandler>
                                <AppRoutes />
                            </SocketEventHandler>
                        </ScrollToTop>
                    </ErrorBoundary>
                </Suspense>
            </BrowserRouter>
        </ContextProvider>
    );
}

export default App;
